import React from 'react';
import { Dimensions, Image, ImageBackground, Platform } from 'react-native'

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { useTheme, getThemeImages } from '../Themes';
import VFHeader from '../VFHeader';

import styles from './VFImageHeader.Styles';

function VFImageHeader({
  withOverlay,
  title,
  image,
  imageStyle,
  imageResizeMode,
  headerStyle,
  ...props
}) {
  const theme = useTheme();
  const Images = getThemeImages(theme.name);
  const getProperTitle = () => (title?.length > 28 ? `${title.substring(0, 25).trim()}...` : title);
  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <>
        <VFHeader title={title} headerStyle={styles.headerStyle} subHeaderMaxHeight={110} {...props} />
        <ImageBackground source={image} style={[styles.image, { width: '100%', borderRadius: 6, overflow: 'hidden' }]} resizeMode="cover">
          {withOverlay && (
            <Image source={Images.header_image_overlay} style={styles.image} />
          )}
        </ImageBackground>
      </>
    )
  }
  return (
    <>
      <VFHeader
        title={getProperTitle()}
        headerStyle={[styles.headerStyle, headerStyle]}
        subHeaderMaxHeight={110}
        {...props}
      />
      <ImageBackground
        source={image}
        style={[styles.image, imageStyle]}
        resizeMode={imageResizeMode}
      >
        {withOverlay && <Image source={Images.header_image_overlay} style={styles.image} />}
      </ImageBackground>
    </>
  );
}
VFImageHeader.defaultProps = {
  withOverlay: true,
  imageStyle: {},
  imageResizeMode: 'cover',
};

VFImageHeader.propTypes = {
  title: PropTypes.string,
  image: PropTypes.object,
  withOverlay: PropTypes.bool,
  imageStyle: ViewPropTypes.object,
  imageResizeMode: PropTypes.string,
  headerStyle: PropTypes.object,
};
export default VFImageHeader;
